import { render, staticRenderFns } from "./fwCarFrame.vue?vue&type=template&id=0ad66ba4&"
import script from "./fwCarFrame.vue?vue&type=script&lang=js&"
export * from "./fwCarFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports